import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";

//MUI
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import FormikControl from "../../components/formik/FormikControl";
import Loader from "../../components/loader/Loader";

import SBGService from "../../services/SBGService";
import { Mode } from "./SBGPage";
import { createAutocompleteOptions } from "../../utility/utils";
import { fetchSBGs } from "../../redux/actions/SBGActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { SBGModel } from "../../models/SBGModel";

const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  sbgUserId: Yup.number().min(1, "Required").required("Requierd"),
  sbgviewers: Yup.array().notRequired(),
  // status: Yup.string().required("Required"),
});

type FormProps = Yup.InferType<typeof validationSchema>;

type Props = {
  mode: Mode;
  handleModalClose: () => void;
  data?: SBGModel;
};

const SBGForm = ({ mode, handleModalClose, data }: Props) => {
  const initialValues = useMemo(
    () => ({
      name: "",
      description: "",
      sbgUserId: 0,
      sbgviewers: [],
      // status: "",
    }),
    []
  );

  const [formState, setFormState] = useState<FormProps>(initialValues);
  const dispatch = useAppDispatch();
  const displayToast = useAppSelector((state) => state.toast.displayToast);
  const allUsers = useAppSelector((state) =>
    state.user.all_Users.filter((rec) => rec.roleId === 4)
  );

  const userOptions = useMemo(() => {
    return createAutocompleteOptions(
      allUsers,
      "userId",
      "firstName",
      "lastName"
    );
  }, [allUsers]);

  useEffect(() => {
    if (mode === "edit" && data) {
      setFormState(() => ({
        name: data.name,
        description: data.description,
        sbgUserId: data.sbguserId,
        sbgviewers: data.sbgviewers
          ? data.sbgviewers.split(",").map((val) => +val)
          : [],
        // status: data.isActive ? "active" : "inactive",
      }));
    }
  }, [mode, data]);

  const submitHandler = async (
    values: FormProps,
    actions: FormikHelpers<FormProps>
  ) => {
    try {
      let formData: SBGModel = {
        sbgid: 0,
        name: "",
        description: "",
        sbguserId: 0,
        sbgviewers: "",
        isActive: true,
        createdDate: new Date(),
        modifiedDate: new Date(),
      };
      if (mode === "add") {
        formData.name = values.name;
        formData.description = values.description;
        formData.sbguserId = values.sbgUserId;
        formData.sbgviewers = values.sbgviewers?.length
          ? values.sbgviewers?.join(",")
          : "";
        // formData.isActive = values.status === "active" ? true : false;
      } else if (data) {
        formData = {
          ...data,
          name: values.name,
          description: values.description,
          sbguserId: values.sbgUserId,
          sbgviewers: values.sbgviewers?.length
            ? values.sbgviewers?.join(",")
            : "",
          // isActive: values.status === "active" ? true : false,
          modifiedDate: new Date(),
        };
      }
      await SBGService.createSBG(formData, data?.sbgid);
      actions.setSubmitting(false);
      handleModalClose();
      dispatch(fetchSBGs());
      displayToast(
        `SBG ${mode === "add" ? "created" : "updated"} successfully`,
        "success"
      );
    } catch (error) {
      actions.setSubmitting(false);
    }
  };
  return (
    <Formik
      initialValues={formState}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
      enableReinitialize={true}
    >
      {(formik) => (
        <>
          <Form>
            <Stack gap={2}>
              <FormikControl
                control="input"
                type="text"
                name="name"
                size="small"
                label="Name"
                placeholder="Enter Name"
              />
              <FormikControl
                control="input"
                multiline
                maxRows={2}
                name="description"
                size="small"
                label="Description"
                placeholder="Enter Description"
              />
              <FormikControl
                control="autocomplete"
                options={userOptions}
                name="sbgUserId"
                size="small"
                label="SBG User"
                placeholder="Select SBG User"
              />
              <FormikControl
                control="autocomplete"
                options={userOptions}
                name="sbgviewers"
                multiple={true}
                size="small"
                label="Select SBG Viewers"
                placeholder="Select SBG Viewers"
              />
              {/* <FormikControl
                control="autocomplete"
                options={statusOptions}
                name="status"
                size="small"
                label="Status"
                placeholder="Select Status"
              /> */}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={formik.isSubmitting}
              >
                Submit
              </Button>
            </Stack>
          </Form>
          {formik.isSubmitting && <Loader />}
        </>
      )}
    </Formik>
  );
};

export default SBGForm;
